import React from "react";

/**餐厅详情 */
export const Profile = ({ restaurant }) => {
  return (
    <article className="page-restaurant--profile">
      {restaurant ? <h3>{restaurant.name}</h3> : null}
    </article>
  );
};
